import { differenceInDays } from "date-fns/differenceInDays";
import { parseISO } from "date-fns/parseISO";
import { bool, number, object, string } from "yup";
import { DRIVE, FLY } from "../shared/constants.js";
const MAXIMUM_BUNDLE_DATE_LENGTH = 330;
const LOCATION_REQUIRED = 'Please enter your City, Airport, Point of Interest, Hotel Name or U.S. Zip Code';
const PKG_LOCATION_REQUIRED = 'Please enter a city or airport';
const PKG_LOCATION_INCORRECT = 'Please select a city or airport to add a flight to your hotel';
const PKG_LOCATION_INCORRECT_CAR = 'Please select a city or airport to add a car to your hotel';
const INVALID_DATE = 'Please select valid dates';
const DISALLOW_INFANT_INTL_FLIGHT = 'Sorry, we do not offer lap infant seating on international flights';
const INFANT_CAPACITY_LIMIT = 'Only one infant per adult is allowed';
const CHILD_AGE_REQUIRED = "Please enter children's age to get the best price for your group";
const MAXIMUM_BUNDLE_GUEST_COUNT = 8;
const BUNDLE_MAX_CAPACITY_ERROR = 'Bundles accommodate up to 8 people. You may need an additional bundle for your group';
const BUNDLE_MAX_DATE_ERROR = `Sorry! We only support bundles up to ${MAXIMUM_BUNDLE_DATE_LENGTH} days in advance. Please choose a date within this window.`;
const intlLocation = (locationObject)=>locationObject && 'string' == typeof locationObject.countryCode && 'US' !== locationObject.countryCode.toUpperCase();
const isInfantFound = (childrenAges)=>Object.values(childrenAges).some((age)=>0 === parseInt(age, 10));
const isLocationWithInfant = (locationObject, childrenAges)=>intlLocation(locationObject) && isInfantFound(childrenAges);
const numOfValidAges = (childrenAges)=>{
    if ('object' == typeof childrenAges && null !== childrenAges) return Object.values(childrenAges).map((age)=>parseInt(age, 10)).filter((num)=>!Number.isNaN(num) && num >= 0);
    return [];
};
const isInfantLimitReachedPackages = (adultCount, childrenAges, tripType)=>{
    const lapInfants = Object.values(childrenAges).filter((age)=>{
        const numAge = parseInt(age, 10);
        return !Number.isNaN(numAge) && 0 === numAge;
    });
    const infantCount = lapInfants.length;
    return tripType.includes(FLY) && infantCount > adultCount;
};
function isChildrenAgeNotProvided(childrenCount, childrenAges) {
    const validAgesCount = numOfValidAges(childrenAges).length;
    return childrenCount > 0 && childrenCount !== validAgesCount;
}
function handleInfantChildrenTravel(formState) {
    const { childrenAges, adults, children } = this.parent;
    const { startLocation, endLocation, tripType } = formState;
    if (tripType.includes(FLY) && endLocation && startLocation && (isLocationWithInfant(endLocation, childrenAges) || isLocationWithInfant(startLocation, childrenAges))) return this.createError({
        message: DISALLOW_INFANT_INTL_FLIGHT,
        path: this.path
    });
    if (isInfantLimitReachedPackages(adults, childrenAges, tripType)) return this.createError({
        message: INFANT_CAPACITY_LIMIT,
        path: this.path
    });
    if (isChildrenAgeNotProvided(children, childrenAges)) return this.createError({
        message: CHILD_AGE_REQUIRED,
        path: this.path
    });
    return true;
}
function handleRoomCapacity(formState) {
    const { adults, children } = this.parent;
    const { tripType } = formState;
    const travelerCount = adults + children;
    if (MAXIMUM_BUNDLE_GUEST_COUNT < travelerCount && (tripType.includes(FLY) || tripType.includes(DRIVE))) return this.createError({
        message: BUNDLE_MAX_CAPACITY_ERROR,
        path: this.path
    });
    return true;
}
function handlePackageLocation() {
    const { endLocation, tripType } = this.parent;
    if (!endLocation) return this.createError({
        message: PKG_LOCATION_REQUIRED,
        path: this.path
    });
    if ('CITY' !== endLocation.type && 'AIRPORT' !== endLocation.type && 'GEO' !== endLocation.type && 'POI' !== endLocation.type) {
        const message = tripType.includes(DRIVE) && !tripType.includes(FLY) ? PKG_LOCATION_INCORRECT_CAR : PKG_LOCATION_INCORRECT;
        return this.createError({
            message,
            path: this.path
        });
    }
    return true;
}
function handleDateCheck() {
    const { tripType } = this.parent;
    const dateValue = this.parent[this.path];
    const dateDiff = differenceInDays(parseISO(dateValue), Date.now());
    if (dateDiff > MAXIMUM_BUNDLE_DATE_LENGTH && (tripType.includes(FLY) || tripType.includes(DRIVE))) return this.createError({
        message: BUNDLE_MAX_DATE_ERROR,
        path: this.path
    });
    return true;
}
const hotelSearchFormSchema = object().shape({
    tripType: string().required(),
    partialStay: bool(),
    startLocation: object().nullable().when('tripType', {
        is: (tripType)=>tripType.includes(FLY),
        then: (schema)=>schema.nullable().required(PKG_LOCATION_REQUIRED)
    }),
    endLocation: object().nullable().when('tripType', {
        is: (tripType)=>tripType.includes(FLY) || tripType.includes(DRIVE),
        then: (schema)=>schema.nullable().test({
                name: 'endLocationPkg',
                test: handlePackageLocation
            }),
        otherwise: (schema)=>schema.nullable().required(LOCATION_REQUIRED)
    }),
    startDate: string().required(INVALID_DATE).test(handleDateCheck),
    endDate: string().required(INVALID_DATE).test(handleDateCheck),
    travelers: object().shape({
        children: number().test({
            name: 'children',
            test () {
                return handleInfantChildrenTravel.call(this, this.options.from[1].value);
            }
        }),
        rooms: number().test({
            name: 'rooms',
            test () {
                return handleRoomCapacity.call(this, this.options.from[1].value);
            }
        })
    })
});
const validation = hotelSearchFormSchema;
export { BUNDLE_MAX_CAPACITY_ERROR, CHILD_AGE_REQUIRED, INFANT_CAPACITY_LIMIT, INVALID_DATE, LOCATION_REQUIRED, PKG_LOCATION_REQUIRED, validation as default, hotelSearchFormSchema, isInfantLimitReachedPackages };
